<template>
  <div>
    <el-form ref="detailForm" class="detail-form" label-width="100px">
      <div :class="['panel-content', 'pad-content']">
        <el-row>
          <el-col :span="12">
            <el-form-item label="子订单编号">
              <span>{{ model.suborderNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="子订单名称">
              <span>{{ model.suborderName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="售卖价格">
              <span>{{ model.settlePrice || 0 }} 元/{{ billType === 3 ? 'CPD' : 'CPM' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="广告位">
              <span>{{ model.spaceName }}</span>
            </el-form-item>
          </el-col>
          <template v-if="billType === 1">
            <el-col :span="12">
              <el-form-item label="下单总量">
                <span>{{ (model.payNumber + model.freeNumber).toLocaleString()}} CPM</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="投放总量">
                <span>{{ (model.payNumber + model.freeNumber + model.addedNumber).toLocaleString()}} CPM</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排期总量">
                <span v-if="model.payNumber">{{ model.payNumber.toLocaleString() }} CPM</span>
                <span v-else>-</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="赠送总量">
                <span v-if="model.freeNumber">{{ model.freeNumber.toLocaleString() }} CPM</span>
                <span v-else>-</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="补量总量">
                <span v-if="model.addedNumber">{{ model.addedNumber.toLocaleString() }} CPM</span>
                <span v-else>-</span>
              </el-form-item>
            </el-col>
          </template>
          <el-col :span="12">
            <el-form-item label="投放时间">
              <span>{{ model.beginDate }} ~ {{ model.endDate }}</span>
            </el-form-item>
          </el-col>
          <template v-if="billType === 3">
            <el-col :span="12">
              <el-form-item label="CPD售卖天数">
                <span v-if="model.cpdDayNumber">{{ model.cpdDayNumber }} 天</span>
                <span v-else>-</span>
              </el-form-item>
            </el-col>
          </template>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      default: () => ({})
    },
    billType: { type: Number }
  },
  computed: {}
}
</script>

<style lang="stylus" scoped>
.detail-form
  overflow auto
.panel-title
  font-size 14px
  font-weight 600
  color #333
.panel-content .el-form-item
  margin-bottom 0
  >>>.el-form-item__label
    color #888
  >>>.el-form-item__content>span
    color #333
</style>
